import { Controller } from "@hotwired/stimulus";

// Keeps the unit name locked until the warning has been opened and the enable button clicked
export default class extends Controller {
  static targets = ["input", "enabler"]

  reveal() {
    this.enablerTarget.classList.remove("d-none")
  }

  enable() {
    this.inputTarget.disabled = false
    this.enablerTarget.remove()
  }
}
